module.exports = __webpack_public_path__ + "img/ilifestyle_left.4850c696.png";